"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractServiceFees = class UcContractServiceFees extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    mapFees(...args) {
        return _
            .chain(args[0])
            .orderBy(['valid_from', 'valid_to'], ['desc', 'desc'])
            .map((item, index, arr) => {
            const future = item.valid_from > this.$fn.today, current = !future && (index == 0 || arr[index - 1].valid_from > this.$fn.today), stale = !future && !current;
            return { item, future, current, stale };
        })
            .value();
    }
    filterFees(...args) {
        const [fees, displayAll] = args;
        return _
            .filter(fees, p => displayAll || p.future || p.current)
            .map(p => p.item);
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    service;
    onService(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("service");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    today;
    async $$load_today() {
        return new Date();
    }
    displayAll;
    fees;
    async $$load_fees() {
        return this.mapFees(this.service.fees);
    }
    hasStaleItems;
    async $$load_hasStaleItems() {
        return _.some(this.fees, { stale: true });
    }
    ux;
    dataMembers = ['today', 'displayAll', 'fees', 'hasStaleItems', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                today: null,
                displayAll: false,
                fees: null,
                hasStaleItems: null,
                ux: null,
            },
        };
    }
    get canDisplayMoreItems() {
        if (this.loaded) {
            return !this.displayAll && this.hasStaleItems;
        }
        return null;
    }
    get canHideItems() {
        if (this.loaded) {
            return this.displayAll && this.hasStaleItems;
        }
        return null;
    }
    async act_6705964765214521_emit_8896_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_6705964765214521_close_8895_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_6705964765214521_showModal_8894_getActionArgs($event) {
        return {
            name: "ContractServiceEditor",
            props: {
                mode: "editServiceFee",
                contract: this.contract,
                service: _.cloneDeep(this.service),
                fee: _.cloneDeep($event.scope.fee),
            },
        };
    }
    async evh_6705964765214521_clickPreventStop(event, scope) {
        return await this.actions.evh_6705964765214521_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_96700093353179_setData_8898_getActionArgs($event) {
        return {
            path: "displayAll",
            value: false,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_96700093353179_clickPreventStop(event, scope) {
        return await this.actions.evh_96700093353179_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_5974459770896956_setData_8900_getActionArgs($event) {
        return {
            path: "displayAll",
            value: true,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5974459770896956_clickPreventStop(event, scope) {
        return await this.actions.evh_5974459770896956_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8852205820859826_emit_8904_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8852205820859826_close_8903_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_8852205820859826_showModal_8902_getActionArgs($event) {
        return {
            name: "ContractServiceEditor",
            props: {
                mode: "addServiceFee",
                contract: this.contract,
                service: _.cloneDeep(this.service),
            },
        };
    }
    async evh_8852205820859826_clickPreventStop(event, scope) {
        return await this.actions.evh_8852205820859826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_6705964765214521_emit_8896 = new core_1.actions.EmitAction({
            actionArgs: this.act_6705964765214521_emit_8896_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_6705964765214521_close_8895 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_emit_8896,
            event: "close",
            when: this.evh_6705964765214521_close_8895_getWhen,
            displayName: "emitReload",
        });
        const act_6705964765214521_showModal_8894 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6705964765214521_showModal_8894_getActionArgs,
            events: [evh_6705964765214521_close_8895],
        });
        const evh_6705964765214521_clickPreventStop_8893 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_showModal_8894,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_6705964765214521_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_clickPreventStop_8893],
        });
        const act_96700093353179_setData_8898 = new core_1.actions.SetDataAction({
            actionArgs: this.act_96700093353179_setData_8898_getActionArgs,
            events: [],
        });
        const evh_96700093353179_clickPreventStop_8897 = new core_1.actions.EventHandlerImpl({
            action: act_96700093353179_setData_8898,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const evh_96700093353179_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_96700093353179_clickPreventStop_8897],
        });
        const act_5974459770896956_setData_8900 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5974459770896956_setData_8900_getActionArgs,
            events: [],
        });
        const evh_5974459770896956_clickPreventStop_8899 = new core_1.actions.EventHandlerImpl({
            action: act_5974459770896956_setData_8900,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const evh_5974459770896956_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5974459770896956_clickPreventStop_8899],
        });
        const act_8852205820859826_emit_8904 = new core_1.actions.EmitAction({
            actionArgs: this.act_8852205820859826_emit_8904_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_8852205820859826_close_8903 = new core_1.actions.EventHandlerImpl({
            action: act_8852205820859826_emit_8904,
            event: "close",
            when: this.evh_8852205820859826_close_8903_getWhen,
            displayName: "emitReload",
        });
        const act_8852205820859826_showModal_8902 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8852205820859826_showModal_8902_getActionArgs,
            events: [evh_8852205820859826_close_8903],
        });
        const evh_8852205820859826_clickPreventStop_8901 = new core_1.actions.EventHandlerImpl({
            action: act_8852205820859826_showModal_8902,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8852205820859826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8852205820859826_clickPreventStop_8901],
        });
        return {
            act_6705964765214521_emit_8896,
            evh_6705964765214521_close_8895,
            act_6705964765214521_showModal_8894,
            evh_6705964765214521_clickPreventStop_8893,
            evh_6705964765214521_clickPreventStop,
            act_96700093353179_setData_8898,
            evh_96700093353179_clickPreventStop_8897,
            evh_96700093353179_clickPreventStop,
            act_5974459770896956_setData_8900,
            evh_5974459770896956_clickPreventStop_8899,
            evh_5974459770896956_clickPreventStop,
            act_8852205820859826_emit_8904,
            evh_8852205820859826_close_8903,
            act_8852205820859826_showModal_8902,
            evh_8852205820859826_clickPreventStop_8901,
            evh_8852205820859826_clickPreventStop,
            emitReload: act_8852205820859826_emit_8904,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractServiceFees.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractServiceFees.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractServiceFees.prototype, "service", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('service'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractServiceFees.prototype, "onService", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcContractServiceFees.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractServiceFees.prototype, "onReadonly", null);
UcContractServiceFees = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractServiceFees);
exports.default = UcContractServiceFees;
vue_property_decorator_1.Vue.component("UcContractServiceFees", UcContractServiceFees);
